var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 48 54",
    style: {
      enableBackground: "new 0 0 48 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#EFEFEF;}\n\t.st2{fill:#C5C5C5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Liderzy---Dashboard",
    transform: "translate(-347.000000, -1231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "movie-lane-2",
    transform: "translate(347.000000, 1231.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: -12,
    y: -9,
    className: "st0",
    width: 72,
    height: 72
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st1",
    d: "M6,0h36c3.31,0,6,2.69,6,6v42c0,3.31-2.69,6-6,6H6c-3.31,0-6-2.69-6-6V6C0,2.69,2.69,0,6,0 z M4.5,6C3.67,6,3,6.67,3,7.5v3C3,11.33,3.67,12,4.5,12h3C8.33,12,9,11.33,9,10.5v-3C9,6.67,8.33,6,7.5,6H4.5z M40.5,6 C39.67,6,39,6.67,39,7.5v3c0,0.83,0.67,1.5,1.5,1.5h3c0.83,0,1.5-0.67,1.5-1.5v-3C45,6.67,44.33,6,43.5,6H40.5z M4.5,18 C3.67,18,3,18.67,3,19.5v3C3,23.33,3.67,24,4.5,24h3C8.33,24,9,23.33,9,22.5v-3C9,18.67,8.33,18,7.5,18H4.5z M40.5,18 c-0.83,0-1.5,0.67-1.5,1.5v3c0,0.83,0.67,1.5,1.5,1.5h3c0.83,0,1.5-0.67,1.5-1.5v-3c0-0.83-0.67-1.5-1.5-1.5H40.5z M4.5,30 C3.67,30,3,30.67,3,31.5v3C3,35.33,3.67,36,4.5,36h3C8.33,36,9,35.33,9,34.5v-3C9,30.67,8.33,30,7.5,30H4.5z M40.5,30 c-0.83,0-1.5,0.67-1.5,1.5v3c0,0.83,0.67,1.5,1.5,1.5h3c0.83,0,1.5-0.67,1.5-1.5v-3c0-0.83-0.67-1.5-1.5-1.5H40.5z M40.5,42 c-0.83,0-1.5,0.67-1.5,1.5v3c0,0.83,0.67,1.5,1.5,1.5h3c0.83,0,1.5-0.67,1.5-1.5v-3c0-0.83-0.67-1.5-1.5-1.5H40.5z M4.5,42 C3.67,42,3,42.67,3,43.5v3C3,47.33,3.67,48,4.5,48h3C8.33,48,9,47.33,9,46.5v-3C9,42.67,8.33,42,7.5,42H4.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    className: "st2",
    d: "M22.06,34.72l7.81-5.34c0.68-0.47,0.86-1.4,0.39-2.08c-0.1-0.15-0.24-0.28-0.39-0.39l-7.81-5.38 c-0.68-0.47-1.62-0.3-2.09,0.39c-0.17,0.25-0.26,0.55-0.26,0.85v10.72c0,0.83,0.67,1.5,1.5,1.5C21.51,34.98,21.81,34.89,22.06,34.72 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.a22aa5d6e671d894070c8d070084ddc5.svg";
export { ForwardRef as ReactComponent };